import TrackingBar from './TrackingBar';

export default TrackingBar;
